// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"757":"8efe12f3","918":"21df5fe0","962":"69674320"}[chunkId] + ".css";
};